// ============================================================================
// TimeWageAuditUpload.jsx
// Both Time and Wage Audit feeds, on a page of their own under Data Uploads.
//
// This used to sit at the bottom of the dashboard. Uploading is a different
// job from reviewing — done by a different person, on a different cadence —
// and a reviewer scrolling past a drop zone every time they read the board is
// the wrong default. The dashboard is now only a dashboard.
//
// ── Who can reach this ──────────────────────────────────────────────────────
// super_admin, OR anyone holding can_review_time_wage_audit. That is wider
// than every other page in Data Uploads, which are super-admin only, and it is
// deliberate: this module's ingestion routes are gated by
// requireTimeWageAuditAccess rather than requireRole('super_admin'), so an HR
// reviewer granted the standalone permission can already upload. Hiding the
// link from them would remove a capability the API still grants — the nav
// would be lying about what they can do.
//
// The route guard (RequireTimeWageAuditAccess in App.jsx) and the nav
// condition in AppShell both match that, and tests/appShellNav.test.jsx
// asserts it.
// ============================================================================

import PageHeader from '../components/Shared/PageHeader';
import IngestionPanel from '../components/TimeWageAudit/IngestionPanel';

export default function TimeWageAuditUpload() {
  return (
    <div style={{ padding: '24px 28px 48px', maxWidth: '1400px', margin: '0 auto' }}>
      <PageHeader
        eyebrow="Data Uploads"
        title="Time and Wage Audit Upload"
        subtitle="Meal break discrepancies from the Samsara Studio export, and post-trip lapses from the shift export. Both are previewed before anything is written, and both upsert on the export's own key — re-uploading the same file refreshes rows rather than duplicating them. Prior confirm/dismiss decisions are never overwritten by an import."
      />
      <IngestionPanel />
    </div>
  );
}
